import React from 'react';
import { useTranslation } from 'react-i18next';

interface ISelectValidation {
  setValue: React.Dispatch<React.SetStateAction<string>>;
  options: string[];
  fullWidth?: boolean;
  isValid: boolean;
  name?: string;
  className?: string;
  onBlur?: (e?: any) => void;
}

const SelectValidation = ({
  setValue,
  options,
  fullWidth = false,
  isValid,
  name,
  className = '',
  onBlur
}: ISelectValidation) => {
  const { t } = useTranslation();
  const errMessage = t('validation.required');
  const newOptions = [...options];
  const disabledOption = options[0];
  newOptions.shift();

  return (
    <div className={className}>
      <div
        {...(fullWidth
          ? { style: { width: '100%', maxWidth: '840px' } }
          : { style: { width: '100%', maxWidth: '412.5px' } })}
      >
        <div>
          <select
            defaultValue={disabledOption}
            onChange={(e) => {
              setValue(e.currentTarget.value);
            }}
            name={name || ''}
            className={`
                    uk-select
                    as-select
                    uk-form-large
                    uk-background-muted
                  ${className}`}
            required
            onBlur={onBlur}
          >
            <option key={disabledOption} disabled>
              {disabledOption}
            </option>
            {newOptions.map((option: string, idx) => (
              <option key={idx}>{option}</option>
            ))}
          </select>

          <div>
            {isValid ? (
              <></>
            ) : (
              <label className="uk-text-danger" style={{ fontSize: '80%' }}>
                {errMessage}
              </label>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectValidation;
